import { anamClient } from './anamClient';
import { isSpeaking } from './anamEvents';

const SPEAKING_IDLE_TIMEOUT_MS = 60_000;

/** Wait until Anam persona finishes speaking, or timeout. */
export function waitForAvatarSpeakingIdle(timeoutMs = SPEAKING_IDLE_TIMEOUT_MS): Promise<void> {
  if (!isSpeaking()) return Promise.resolve();
  return new Promise((resolve) => {
    const timeout = setTimeout(resolve, timeoutMs);
    const unsub = anamClient.onSpeakingChange((speaking) => {
      if (!speaking) {
        clearTimeout(timeout);
        unsub();
        resolve();
      }
    });
  });
}
